export default __webpack_public_path__ + "static/media/Moj.5964fa5c.svg";